/**
 * The page backdrop: a soft vertical wash and one large helix from the logo
 * at 6% opacity, bottom right, bleeding off the viewport. Fixed, so the card
 * scrolls over it. The SVG is inline, so it costs no network request, which
 * matters on an enterprise network that may block anything unexpected.
 *
 * Decorative only. Hidden from assistive technology, never takes a pointer
 * event, never animates. All text sits on the opaque card above it.
 */

import { HELIX } from '../theme/helix.ts';

export function Backdrop() {
  return (
    <div className="backdrop" aria-hidden="true">
      <svg viewBox={HELIX.viewBox} focusable="false">
        <path d={HELIX.d} fill="currentColor" fillRule={HELIX.fillRule} />
      </svg>
    </div>
  );
}
